import {
  TextField,
  Paper,
  Box,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  InputAdornment,
  TablePagination,
  styled,
  tableCellClasses,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useMutation } from "react-query";
import { getAllPatients } from "../patientEncounter/services";
import { useNavigate } from "react-router-dom";
import patientCareRouteList from "../routeList";
import { base } from "../../constants";
import moduleRoutes from "../../routes/moduleRouteList";
import { useEffect, useState } from "react";
export type PatientType = {
  id: number;
  status: number;
  encounterId: number | null;
  emiratesId: string;
  gender: string;
  age: number;
  patientId: string;
  mobileNo: string;
  firstName: string;
  middleName: string;
  lastName: string;
  dob: string;
  foDate: string;
  isVip: number;
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: 14,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  cursor: "pointer",
  transition: "background-color 0.2s",
  "&:nth-of-type(odd)": {
    backgroundColor: alpha(theme.palette.action.hover, 0.05),
  },
  "&:hover": {
    backgroundColor: `${alpha(theme.palette.primary.main, 0.08)} !important`,
  },
}));

import { alpha } from "@mui/material/styles";

const PatientHistoryListing = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const {
    mutate: searchPatient,
    data: allpatientsList,
    isLoading,
  } = useMutation(getAllPatients);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    searchPatient(value);
  };

  const handleSelectPatient = (patient: any) => {
    if (patient) {
      navigate(
        `${base}${moduleRoutes.mainRoute}/patient-care/${patientCareRouteList.patientDetailsHistory}/${patient.id}/${patient.patientId}`,
        { state: patient },
      );
    }
  };

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const patients = allpatientsList?.response || [];
  const paginatedPatients = patients.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  useEffect(() => {
    searchPatient("a");
  }, []);
  return (
    <Box p={3} sx={{ bgcolor: "#f8fafc", minHeight: "100vh" }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          borderRadius: "16px",
          border: "1px solid #eef2f6",
          boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
        }}
      >
        <Box mb={3}>
          <Typography
            variant="h5"
            fontWeight="800"
            color="primary.main"
            gutterBottom
          >
            Patient Registry
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Search for a patient using Name, EMR Number, or Mobile to access
            their clinical history.
          </Typography>
        </Box>

        <Box sx={{ mb: 4, maxWidth: 500 }}>
          <TextField
            fullWidth
            placeholder="Search by Name, EMR ID, or Phone..."
            value={searchValue}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Divider sx={{ mb: 4 }} />
        <TableContainer
          component={Box}
          sx={{
            borderRadius: "12px",
            border: "1px solid #eef2f6",
            overflow: "hidden",
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>EMR ID</StyledTableCell>
                <StyledTableCell>Patient Name</StyledTableCell>
                <StyledTableCell>Gender</StyledTableCell>
                <StyledTableCell>Mobile No</StyledTableCell>
                <StyledTableCell>Civil ID</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 10 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : paginatedPatients.length > 0 ? (
                paginatedPatients.map((patient: any) => (
                  <StyledTableRow
                    key={patient.id}
                    onClick={() => handleSelectPatient(patient)}
                  >
                    <StyledTableCell
                      sx={{ color: "primary.main" }}
                    >
                      {patient.patientId}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography variant="body2">
                        {`${patient.firstName} ${patient?.middleName || ""} ${patient.lastName}`}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>{patient.gender || "-"}</StyledTableCell>
                    <StyledTableCell>{patient.mobileNo || "-"}</StyledTableCell>
                    <StyledTableCell>
                      {patient.emiratesId || "-"}
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 10 }}>
                    <Typography color="textSecondary">
                      No patients found matching your search.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {patients.length > 0 && (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={patients.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default PatientHistoryListing;
